<template>
  <div>
    <v-text-field
      class="ml-16"
      :name="name_property"
      label="回答を入力"
      v-model="datas.saveValue"
      required
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'FieldArea',
  components: {
  },
  props: {
    datas: {
      type: Object,
      required: true
    },
    name_property: {
      type: String,
      required: true
    }
  }
}
</script>
